import CheckoutErrorModal from './CheckoutErrorModal';

export default CheckoutErrorModal;


// WEBPACK FOOTER //
// ./src/components/CheckoutErrorModal/index.jsx